import React, { Children } from 'react';
import PropTypes from 'prop-types';
import '../styles/hcHomepageStyles.css';

export const ActivityCardTable = (props) => {
    return (
        <div className="activityCardTable">
            {Children.count(props.children) === 0 ? 
                <span id="noActivities">More Activities Coming Soon!</span> : props.children}
        </div>
    );
};

ActivityCardTable.propTypes = {
    children: PropTypes.array.isRequired,
};

export default ActivityCardTable;



// WEBPACK FOOTER //
// ./src/components/ActivityCardTable.jsx